import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from "react";
import App from "./app/App";
import { createRoot } from 'react-dom/client';
const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<App />);